module.exports = __webpack_public_path__ + "img/1.90b35f7.png";